
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouterOff as ObiRouterOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-router-off.js';
 
 
 

 
 export const ObiRouterOff = createComponent({
   react: React,
   tagName: 'obi-router-off',
   elementClass: ObiRouterOffElement,
   events: {
     
   }
  });
 
 